import React, { useEffect, useState } from "react";
import styled from "styled-components";
import { ButtonL, ButtonS } from "../../styles/Common";
import { ReactComponent as IcoClose } from "../../styles/images/ico_close_modal.svg";
// Modal 1
// When the confirm button is clicked, execute func and then close the modal
const SlideModal = (props) => {
  const {
    btnText,
    setOpenModal,
    closeModalFunc,
    callbackFunc,
    btnDisabled,
    autoClose,
  } = props;
  const [modalHeight, setModalHeight] = useState("-100%");
  useEffect(() => {
    // Set modal height after render

    setModalHeight(0);
  }, [setModalHeight]);

  return (
    <ModalWrapper>
      <ModalContainer modalHeight={modalHeight}>
        <ModalBody>
          <ModalHeader>
            <IcoClose
              onClick={() => {
                closeModalFunc();
                setOpenModal(false);
              }}
            ></IcoClose>
          </ModalHeader>
          <ModalMsg>{props.children}</ModalMsg>
          <ModalBtns>
            <ButtonL
              disabled={btnDisabled}
              onClick={
                autoClose
                  ? () => {
                      callbackFunc();
                      closeModalFunc();
                      setOpenModal(false);
                    }
                  : () => {
                      callbackFunc();
                    }
              }
            >
              {btnText}
            </ButtonL>
          </ModalBtns>
        </ModalBody>
      </ModalContainer>
    </ModalWrapper>
  );
};

export default SlideModal;

const ModalWrapper = styled.div`
  position: fixed;
  top: 0;
  right: 0;
  width: 100vw;
  height: 100%;

  background-color: rgba(37, 21, 98, 0.1);
  z-index: 99999;
`;

const ModalContainer = styled.div`
  position: absolute;
  /* min-height: 36rem; */
  height: fit-content;
  margin: auto;
  bottom: ${({ modalHeight }) => modalHeight};
  transition: bottom 0.5s; /* Apply transition effect */
  /* bottom: 0; */
  right: 0;
  left: 0;
  color: ${({ theme }) => theme.color.white};
  background-color: ${({ theme }) => theme.color.purple_light};
  box-shadow: 0px -10px 10px 0px rgba(37, 21, 98, 0.15);
  text-align: center;
  input {
    background-color: transparent;
  }
`;

const ModalBody = styled.div`
  h3 {
    font-size: 2rem;
    font-weight: 400;
    line-height: 2.4rem; /* 120% */
  }
  p {
    font-size: 1.6rem;
    /* font-weight: 700; */
    line-height: 2rem; /* 125% */
  }
  .smallP {
    font-size: 1.4rem;
    font-weight: 400;
    line-height: 1.8rem; /* 128.571% */

    margin-top: 1rem;
  }
`;

const ModalHeader = styled.div`
  text-align: right;
  padding: 2rem 2rem 1.2rem 2rem;
`;
const ModalMsg = styled.div`
  padding: 0 3rem;
`;
const ModalBtns = styled.div`
  padding: 0 1.6rem 1.6rem 1.6rem;
  button {
    width: 100%;
  }
`;
